(() => {
  App.ui = App.ui || {};

  const moduleName = 'commonEvents';

  App.ui[moduleName] = (() => {
    const applyBackground = function () {
      const isDesktop = App.global.isDesktop();
      const background = App.settings.background || {};
      const backgroundProps = isDesktop
        ? background.url + background.properties
        : '';
      if (background.active) {
        $('body')
          .toggleClass('page-with-background', isDesktop)
          .css('background', backgroundProps);
      }
    };

    const delegate = function () {
      if (App.global.isDesktop()) {
        $('a[href^="tel:"]').on('click', (e) => {
          e.preventDefault();
        });
      }

      $(window).on('resize', () => {
        App.global.specifyDevice();
        applyBackground();
      });

      $(window).on('load', () => {
        App.global.enablePrerender();
      });

      // this works because all ajax requests except login has csrf exclusion on server side
      $(window).on('focus', () => {
        $.ajax({
          url: '/csrf/isValid',
          type: 'GET',
          headers: {
            'X-Ajax-call': 'true',
            csrfTokenForCheck: $('meta[name=_csrf]').attr('content'),
          },
        })
          .done((data) => {
            const dataParsed = JSON.parse(data);
            if (!dataParsed.isValid) {
              window.location.reload(true);
            }
          })
          .fail((error) => {
            App.sendErrorToRaygun(error);
          });
      });

      $(document)
        .on('click', 'a[href="/j_spring_security_logout"], a[href="j_spring_security_logout"]', (e) => {
          e.preventDefault();
          $.ajax({
            url: '/j_spring_security_logout',
            type: 'POST',
          })
            .always(() => {
              window.location.href = App.global.getRedirectUrl('/');
            });
        });
    };

    return {
      delegate,
    };
  })();
})();
